import React from 'react';
import ArenaTable from './ArenaTable';
import { TableObject } from './TableObject';

export default function ArenaNew22Table({
    totalTables = [],
    toggleTableSelection,
    BaseURL,
    translate,
    isAds = false,
    renderPrice = false
}) {
    const vipText = translate('web.vvipPlatForm', 'VVIP Platform');

    // Unified arena and table dimensions with 85px VIP box and zero gap between tables
    const imageWidth = 1074;
    const containerWidth = 1100;
    const paddingLeft = 243;
    const vipWidth = 85;

    // Entrance indicator offsets aligned with left walkway, center VVIP, and right walkway
    const leftEntranceMargin = 218;
    const vipEntranceOffset = 318;
    const rightEntranceOffset = 317;

    return (
        <div className="bookingTableContainer" style={{ direction: 'ltr', width: containerWidth, paddingLeft: 0, paddingRight: 0 }}>
            <div className="bookingTableCenter">
                <div className="BookingTableArena" style={{ direction: 'ltr' }}>
                    <img
                        style={{ width: imageWidth, height: 'unset', aspectRatio: 'unset', background: '#FFFFFF' }}
                        src={`${BaseURL}/assets/img/ArenaNew22Table.png`}
                        alt="Horse Arena"
                    />
                </div>
            </div>

            {/* Row 1 (Orange Section in floorplan - 10 tables: 5 left, VIP, 5 right - leaving open walkways on left and right) */}
            <div className="bookingTablesRow withVIPSection mt-2" style={{ paddingLeft }}>
                {totalTables
                    .filter((item) => Number(item.tableNo) >= 1 && Number(item.tableNo) <= 5)
                    .reverse()
                    .map((item) => (
                        <ArenaTable
                            key={item.tableNo}
                            tableNumber={item.tableLetter ?? item.tableNo}
                            tablePrice={item.price}
                            renderPrice={renderPrice}
                            state={TableObject.fromRaw(item).state()}
                            onClick={() => toggleTableSelection(item.id, item.price)}
                            style={{ width: 60 }}
                        />
                    ))}

                <div
                    className="vipSection"
                    style={{
                        width: vipWidth,
                        height: 50,
                        fontSize: 11,
                        lineHeight: 'normal',
                        padding: '0 6px',
                        background: '#1f64aa',
                        borderColor: '#1f64aa',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#ffffff',
                        fontWeight: 'bold',
                        borderRadius: 4,
                        textAlign: 'center',
                        boxSizing: 'border-box'
                    }}
                >
                    {vipText}
                </div>

                {totalTables
                    .filter((item) => Number(item.tableNo) >= 6 && Number(item.tableNo) <= 10)
                    .reverse()
                    .map((item) => (
                        <ArenaTable
                            key={item.tableNo}
                            tableNumber={item.tableLetter ?? item.tableNo}
                            tablePrice={item.price}
                            renderPrice={renderPrice}
                            state={TableObject.fromRaw(item).state()}
                            onClick={() => toggleTableSelection(item.id, item.price)}
                            style={{ width: 60 }}
                        />
                    ))}
            </div>

            {/* Row 2 (Green Section in floorplan - 12 tables: 6 left, VIP, 6 right - matching row 1 width) */}
            <div className="bookingTablesRow withVIPSection secondVIPRow mt-2" style={{ paddingLeft }}>
                {totalTables
                    .filter((item) => Number(item.tableNo) >= 11 && Number(item.tableNo) <= 16)
                    .reverse()
                    .map((item) => (
                        <ArenaTable
                            key={item.tableNo}
                            tableNumber={item.tableLetter ?? item.tableNo}
                            tablePrice={item.price}
                            renderPrice={renderPrice}
                            state={TableObject.fromRaw(item).state()}
                            onClick={() => toggleTableSelection(item.id, item.price)}
                            style={{ width: 50 }}
                        />
                    ))}

                <div
                    className="vipSection"
                    style={{
                        width: vipWidth,
                        height: 50,
                        fontSize: 11,
                        lineHeight: 'normal',
                        padding: '0 6px',
                        background: '#1f64aa',
                        borderColor: '#1f64aa',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#ffffff',
                        fontWeight: 'bold',
                        borderRadius: 4,
                        textAlign: 'center',
                        boxSizing: 'border-box'
                    }}
                >
                    {vipText}
                </div>

                {totalTables
                    .filter((item) => Number(item.tableNo) >= 17 && Number(item.tableNo) <= 22)
                    .reverse()
                    .map((item) => (
                        <ArenaTable
                            key={item.tableNo}
                            tableNumber={item.tableLetter ?? item.tableNo}
                            tablePrice={item.price}
                            renderPrice={renderPrice}
                            state={TableObject.fromRaw(item).state()}
                            onClick={() => toggleTableSelection(item.id, item.price)}
                            style={{ width: 50 }}
                        />
                    ))}
            </div>

            {/* Entrances indicator row aligned with walkways and central VIP */}
            <div className="bookingTablesRow mt-3" style={{ paddingLeft: 0 }}>
                <div style={{ marginLeft: leftEntranceMargin, textAlign: 'center', maxWidth: 40 }}>
                    <div style={{ width: 20, height: 10, background: '#409A97' }} />
                    <div style={{ marginLeft: -10 }}>
                        <i className="fa-solid fa-up-long" style={{ color: '#409A97' }}></i>
                    </div>
                    <div style={{ fontSize: 13, width: 125, marginLeft: 0, textAlign: 'left' }}>
                        {translate('web.audienceEntrance', 'Audience Entrance')}
                    </div>
                </div>
                <div style={{ marginLeft: vipEntranceOffset, textAlign: 'center', maxWidth: 40 }}>
                    <div style={{ width: 20, height: 10, background: '#1f64aa' }} />
                    <div style={{ marginLeft: -11 }}>
                        <i className="fa-solid fa-up-long" style={{ color: '#1f64aa' }}></i>
                    </div>
                    <div style={{ fontSize: 13, marginLeft: '-45px', width: 125 }}>
                        {translate('web.VIPEntrance', 'VIP Entrance')}
                    </div>
                </div>
                <div style={{ marginLeft: rightEntranceOffset, textAlign: 'center', maxWidth: 40 }}>
                    <div style={{ width: 20, height: 10, background: '#409A97' }} />
                    <div style={{ marginLeft: -10 }}>
                        <i className="fa-solid fa-up-long" style={{ color: '#409A97' }}></i>
                    </div>
                    <div style={{ fontSize: 13, width: 125, marginLeft: '-60px', textAlign: 'left' }}>
                        {translate('web.audienceEntrance', 'Audience Entrance')}
                    </div>
                </div>
            </div>
        </div>
    );
}
